import { render, staticRenderFns } from "./OrderOverviewPage.vue?vue&type=template&id=382c46a4&scoped=true"
import script from "./OrderOverviewPage.vue?vue&type=script&lang=js"
export * from "./OrderOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./OrderOverviewPage.vue?vue&type=style&index=0&id=382c46a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c46a4",
  null
  
)

export default component.exports